import type { FaireProductEntity } from "../../entity_types/product";

export const p_fd8b2ebnsv: FaireProductEntity = {
  token: "p_fd8b2ebnsv",
  type: "product",
  name: "hydrangea bouquet watercolor wall art print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/f30fc74c189d53054228696a87387fe725560c8dd38596972b4d4df7ee0e70bf.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    "Display this lovely print of a hydrangea bouquet throughout your home.\n\n• Print of original watercolor artwork by Emily Lex\n• Printed in full color on thick, superfine paper\n• Packaged in a clear protective sleeve with chipboard backing\n• Frame and mat not included",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:52.832Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
